var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCategory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "53px",
    viewBox: "0 0 50 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "empty category") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-794.000000, -613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-category",
    transform: "translate(794.000000, 611.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D8D8D8",
    opacity: 0.293410528,
    cx: 25,
    cy: 53.5,
    rx: 25,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "archive",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9387097,23.9214231 L40.2612903,0.49834618 C40.1363739,0.196599816 39.8422815,0 39.516129,0 L10.483871,0 C10.158012,0 9.86432005,0.196871299 9.73951613,0.49834618 L0.0620967742,23.9214231 L0,24.2307693 L0,38.7692308 C0,40.5535354 1.44424274,42 3.22580645,42 L46.7741935,42 C48.5557573,42 50,40.5535354 50,38.7692308 L50,24.2307693 L49.9387097,23.9214231 Z M11.0225806,1.61538464 L38.9774194,1.61538464 L47.983871,23.4230769 L33.0645161,23.4230769 C32.6191252,23.4230769 32.2580645,23.7846931 32.2580645,24.2307693 L32.2580645,30.6923077 L17.7419355,30.6923077 L17.7419355,24.2307693 C17.7419355,23.7846931 17.3808748,23.4230769 16.9354839,23.4230769 L2.01612903,23.4230769 L11.0225806,1.61538464 Z",
    id: "Shape",
    fill: "#CBCBCB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sad",
    opacity: 0.285132999,
    transform: "translate(17.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#888888",
    strokeLinecap: "square",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#888888",
    strokeLinecap: "square",
    cx: 15.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,9 C5.03072989,7.14372262 6.93693427,6 9,6 C11.0630657,6 12.9692701,7.14372262 14,9",
    id: "Path",
    stroke: "#888888",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#888888",
    fillRule: "nonzero",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#888888",
    fillRule: "nonzero",
    cx: 15.5,
    cy: 1.5,
    r: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCategory);
export default __webpack_public_path__ + "static/media/empty-category.44de3eee895b958a71b60afc91f4e4e4.svg";
export { ForwardRef as ReactComponent };